<script>
	import { TwitchIcon, VideoIcon, PlusCircleIcon, CheckCircleIcon } from 'svelte-feather-icons';
	import { faDiscord } from '@fortawesome/fontawesome-free-brands';
	import { createEventDispatcher } from 'svelte';
	var dispatch = createEventDispatcher();
	import { onMount } from 'svelte';
	import { io } from './store.js';
	
	onMount(() => {
		console.log($io)
		window.io = $io;
	});
	
</script>

<div class='con-page'>
	<div class='con-dash' style=''>
		
		<div class='div-floating-cards' style='position:absolute;left:0;'>
			<img class='img-floating-card floater1' src='c1.PNG' style='left:50px;' />
			<img class='img-floating-card floater2' src='c2.PNG' style='right:50px;' />
			<img class='img-floating-card floater3' src='c3.PNG' style='left:150px; top:200px;' />
			<img class='img-floating-card floater1' src='c4.PNG' style='right:300px; top:150px;' />
			<img class='img-floating-card floater2' src='c5.PNG' style='right:100px; top:200px;' />
		</div>

		<div class='landing-header' style='margin-bottom:50px; font-size:3.1em;'>
			Collect your favorite cards and play against your friends
		</div>
		<!--
		<a class="topgg" href="https://top.gg/bot/1217169611284549776" >
			<img alt="Karuta" src="https://top.gg/api/widget/1217169611284549776.svg">
		</a>-->

		<div class='btn' on:click={()=>{ window.open('https://top.gg/bot/1217169611284549776', '_blank') }} style='display:grid; align-items:center; grid-template-columns: auto auto; gap:10px;'>
			<CheckCircleIcon />
			Vote for FGCards
		</div>

		<div style='margin:20px; display:grid; grid-template-columns:min-content min-content; gap:20px;'>
			<div on:click={()=>{window.open("https://discord.gg/vA677QqXBz", '_blank')}} class='btn' style='display:grid; align-items:center; grid-template-columns: auto auto; gap:10px;'>
				<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-discord" viewBox="0 0 16 16">
					<path d="M13.545 2.907a13.2 13.2 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.2 12.2 0 0 0-3.658 0 8 8 0 0 0-.412-.833.05.05 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.04.04 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032q.003.022.021.037a13.3 13.3 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019q.463-.63.818-1.329a.05.05 0 0 0-.01-.059l-.018-.011a9 9 0 0 1-1.248-.595.05.05 0 0 1-.02-.066l.015-.019q.127-.095.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.05.05 0 0 1 .053.007q.121.1.248.195a.05.05 0 0 1-.004.085 8 8 0 0 1-1.249.594.05.05 0 0 0-.03.03.05.05 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.2 13.2 0 0 0 4.001-2.02.05.05 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.03.03 0 0 0-.02-.019m-8.198 7.307c-.789 0-1.438-.724-1.438-1.612s.637-1.613 1.438-1.613c.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612m5.316 0c-.788 0-1.438-.724-1.438-1.612s.637-1.613 1.438-1.613c.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612"/>
				  </svg>
				Join the Discord
			</div>

			<div class='btn' on:click={()=>{ window.open('https://discord.com/oauth2/authorize?client_id=1217169611284549776&permissions=3136&scope=bot', '_blank') }} style='display:grid; align-items:center; grid-template-columns: auto auto; gap:10px;'>
				<PlusCircleIcon />
				Add to your Discord
			</div>
		</div>

		<hr />

		<div class='landing-header y' >
			Get cards, display them, make a team and play!
		</div>

		<div class='landing-header-s' >
			Get card drops from the bot and collect your favorite characters from different Fighting Games. There's multiple rarities and card conditions. Will you get them all?
		</div>

		<div class='landing-header-s' >
			All cards can be upgraded, customized and displayed, and you can use them for an engaging PVP gamemode you can play with anyone on your server.
		</div>

		<div style='display:grid; grid-template-columns:auto auto; width:100%;justify-items:center; margin:40px;'>
			<img src='bot.PNG' style='max-width:100%;; max-height:400px;' />
			<img src='versus.PNG' style='max-width:100%;' />
		</div>

		<hr />

	</div>
</div>

<style type="text/less">

	.btn{
		background-color:#f6ff00;
		color:black;
		border-radius:10px;
		padding: 15px 25px;
		font-size:1.1em;
	}

	.div-floating-cards{
		z-index:-10;
		width:100%;
		.img-floating-card{
			position:absolute;
			width:130px;
		}
	}

	:global(.y){
		color: #f6ff00f1;
	}

	:global(hr){
		color:#f6ff00;
		width:100%;
	}

	.con-page{
		display:grid;


	}
	.con-dash{
		display:grid;
		justify-self:center;
		justify-items:center;
		width: 100%;
		max-width:var(--mwidth);
		//margin-top:30px;
		margin-top:10px;
		
		padding:30px;
		padding-bottom:10px;
	}

	.landing-header-s{
		text-align:center;
		font-weight:600;
		font-size:1.2em;
		margin: 15px 0;
		line-height:1.5em;
		padding:10px 50px;
		font-family: 'Open Sans';
	}

	.landing-header{
		text-shadow: 
    -1px -1px 0 #000,  
     1px -1px 0 #000,
    -1px  1px 0 #000,
     1px  1px 0 #000;

		text-align:center;
		font-weight:bold;
		font-size:2.6em;
		margin: 30px 0;
	}

	.floater1 {
		animation: entrance 4s ease-out, float 5s ease-in-out infinite;
	}

	.floater2 {
		animation: entrance 4s ease-out, float 6s ease-in-out infinite;
	}

	.floater3 {
		animation: entrance 4s ease-out,  float 7s ease-in-out infinite;
	}

	@keyframes entrance {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}

	@keyframes float {
		0% {
			transform: translateY(0px);
		}
		50% {
			transform: translateY(-10px);
		}
		100% {
			transform: translateY(0px);
		}
	}

</style>